import { getService, postService } from "services/commonServices";
import { appBaseUrl } from "utils/config";

export class PrimaryReferenceOther {
    primaryRefrenceAdd(body) {
        let url = `${appBaseUrl}/referenceManagement/referenceOthersPrimaryAdd`;
        let data = postService(url, body);
        return data;
    }
};